import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MainComponent } from '../main/main.component';
import { NzLayoutModule, NzNotificationModule, NzSpinModule, NzStatisticModule } from 'ng-zorro-antd';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { MobileHeaderComponent } from './mobile-header/mobile-header.component';


@NgModule({
  declarations: [HeaderComponent, MainComponent, LoaderComponent, MobileHeaderComponent],
  imports: [
    CommonModule,
    NzLayoutModule,
    RouterModule,
    NzNotificationModule,
    NzStatisticModule,
    NzSpinModule
  ],
  exports: [HeaderComponent, MainComponent, LoaderComponent, MobileHeaderComponent]
})
export class LayoutModule { }
